<template>
  <div>
    <v-tabs v-model="tab" centered>
      <v-tab>{{ $t('menuHeaders.reportedByContractor')}}</v-tab>
      <v-tab>{{ $t('menuHeaders.reportedByEmployer')}}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <CommonVariationView
          type="early_warning"
          reporter="contractor"
          :contract="contract"
          :items="contractorEarlyWarnings"
          @FETCH_DATA="handleFetchData"
          :form-fields="formFields"
        />
      </v-tab-item>
      <v-tab-item>
        <CommonVariationView
          type="early_warning"
          reporter="employer"
          :contract="contract"
          :items="employerEarlyWarnings"
          @FETCH_DATA="handleFetchData"
          :form-fields="formFields"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { getVariationsForContract } from '@/services'
import { SITES } from '@/helpers'

export default {
  name: 'EarlyWarnings',
  props: {
    contract: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      items: [],
      tab: 0,
      formFields: ['toVariation', 'toClaim']
    }
  },
  computed: {
    employerEarlyWarnings () {
      return this.items.filter(i => i.reportingSide === SITES.employer)
    },
    contractorEarlyWarnings () {
      return this.items.filter(i => i.reportingSide === SITES.contractor)
    }
  },
  mounted () {
    if (this.contract && this.contract.id) {
      this.handleFetchData(this.contract.id)
    }
  },
  methods: {
    async handleFetchData () {
      this.items = await getVariationsForContract(this.contract.id, 'early_warning')
    }
  },
  watch: {
    contract () {
      this.handleFetchData()
    }
  }
}
</script>
